import { IMapLayerOptions, IPoint, Map, MapLayer } from "./kelydra-map";
import proj4 from 'proj4';

//TODO Gestire caso multimappa
export class ProjUtils {

  static proj:proj4.Converter;

  static init(crs:string) {
    if (!ProjUtils.proj) {
      proj4.defs("EPSG:3003","+proj=tmerc +lat_0=0 +lon_0=9  +k=0.999600 +x_0=1500000 +y_0=0 +ellps=intl +units=m +no_defs");
      proj4.defs("EPSG:3004","+proj=tmerc +lat_0=0 +lon_0=15 +k=0.999600 +x_0=2520000 +y_0=0 +ellps=intl +units=m +no_defs +towgs84=-104.1,-49.1,-9.9,0.971,-2.917,0.714,-11.68");
      ProjUtils.proj = proj4(crs);
    } 
  }

  static projForward(p:IPoint):IPoint {
    return ProjUtils.proj.forward(p);
  }

  static projInverse(p:IPoint):IPoint {
    return ProjUtils.proj.inverse(p);
  }


}

export class TileUtils {

  public static readonly EARTH_CIR_METERS = 40075016.686;
  public static readonly degreesPerMeter = 360 / TileUtils.EARTH_CIR_METERS;

  public static toRadians(degrees:number) {
    return degrees * Math.PI / 180;
  }

  public static readonly metersPerPixelEW:number[] = [
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 0 + 8), //Zoom 0 
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 1 + 8), //Zoom 1 
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 2 + 8), //Zoom 2 
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 3 + 8), //Zoom 3  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 4 + 8), //Zoom 4 
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 5 + 8), //Zoom 5  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 6 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 7 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 8 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 9 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 10 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 11 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 12 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 13 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 14 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 15 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 16 + 8), //Zoom 6  
    TileUtils.EARTH_CIR_METERS / Math.pow(2, 17 + 8), //Zoom 6  
  ] 

  public static tile2long(x:number,z:number):number {
    return (x/Math.pow(2,z)*360-180);
  }

  public static tile2lat(y:number,z:number) {
    var n=Math.PI-2*Math.PI*y/Math.pow(2,z);
    return (180/Math.PI*Math.atan(0.5*(Math.exp(n)-Math.exp(-n))));
  }

  public static lon2tile(lon:number,zoom:number):number { 
    return (Math.floor((lon+180)/360*Math.pow(2,zoom))); 
  }

  public static lat2tile(lat:number,zoom:number):number  { 
    return (Math.floor((1-Math.log(Math.tan(lat*Math.PI/180) + 1/Math.cos(lat*Math.PI/180))/Math.PI)/2 *Math.pow(2,zoom))); 
  }

  public static numericSolve(A:any,b:any) { 
    return TileUtils.numericLUsolve(TileUtils.numericLU(A), b); 
  }
  
  public static numericLU(A:any) {
  
    var abs = Math.abs;
    var i, j, k, absAjk, Akk, Ak, Pk, Ai;
    var max;
    var n = A.length, n1 = n-1;
    var P = new Array(n);
  
    for (k = 0; k < n; ++k) {
      Pk = k;
      Ak = A[k];
      max = abs(Ak[k]);
      for (j = k + 1; j < n; ++j) {
        absAjk = abs(A[j][k]);
        if (max < absAjk) {
          max = absAjk;
          Pk = j;
        }
      }
      P[k] = Pk;
  
      if (Pk != k) {
        A[k] = A[Pk];
        A[Pk] = Ak;
        Ak = A[k];
      }
  
      Akk = Ak[k];
  
      for (i = k + 1; i < n; ++i) {
        A[i][k] /= Akk;
      }
  
      for (i = k + 1; i < n; ++i) {
        Ai = A[i];
        for (j = k + 1; j < n1; ++j) {
          Ai[j] -= Ai[k] * Ak[j];
          ++j;
          Ai[j] -= Ai[k] * Ak[j];
        }
        if(j===n1) Ai[j] -= Ai[k] * Ak[j];
      }
    }
  
    return {
      LU: A,
      P:  P
    };
  }
  
  public static numericLUsolve(LUP:any, b:any) {
    var i, j;
    var LU = LUP.LU;
    var n   = LU.length;
    var x = [...b];
    var P   = LUP.P;
    var Pi, LUi, LUii, tmp;
  
    for (i=n-1;i!==-1;--i) x[i] = b[i];
    for (i = 0; i < n; ++i) {
      Pi = P[i];
      if (P[i] !== i) {
        tmp = x[i];
        x[i] = x[Pi];
        x[Pi] = tmp;
      }
  
      LUi = LU[i];
      for (j = 0; j < i; ++j) {
        x[i] -= x[j] * LUi[j];
      }
    }
  
    for (i = n - 1; i >= 0; --i) {
      LUi = LU[i];
      for (j = i + 1; j < n; ++j) {
        x[i] -= x[j] * LUi[j];
      }
  
      x[i] /= LUi[i];
    }
  
    return x;
  }
  
  
  public static numericDotMV(x:any,y:any) {
    var p = x.length;
      var ret = Array(p);
      for(var i=p-1;i>=0;i--) {
      ret[i] = TileUtils.numericDotVV(x[i],y); 
    }
      return ret;
  }
  
  public static numericDotVV(x:any,y:any) {
      var i,n=x.length,i1,ret = x[n-1]*y[n-1];
      for(i=n-2;i>=1;i-=2) {
          i1 = i-1;
          ret += x[i]*y[i] + x[i1]*y[i1];
      }
      if(i===0) { ret += x[0]*y[0]; }
      return ret;
    
  }
  
  
  public static numericDotSV(x:any,y:any) {
    var _n = y.length;
    var i, ret = Array(_n);
  
    for(i=_n-1;i!==-1;--i) {
      ret[i] = x * y[i]
    }
    return ret;
  }
  
  public static calcTransform(from:IPoint[], to:IPoint[]) {
    var t = Date.now();  
      
      var A, H, b, h, i, k, k_i, l, lhs, m, ref, rhs;
      console.assert((from.length === (ref = to.length) && ref === 4));
      A = []; // 8x8
      for (i = k = 0; k < 4; i = ++k) {
        A.push([from[i].x, from[i].y, 1, 0, 0, 0, -from[i].x * to[i].x, -from[i].y * to[i].x]);
        A.push([0, 0, 0, from[i].x, from[i].y, 1, -from[i].x * to[i].y, -from[i].y * to[i].y]);
      }
      b = []; // 8x1
      for (i = l = 0; l < 4; i = ++l) {
        b.push(to[i].x);
        b.push(to[i].y);
      }
      // Solve A * h = b for h
      h = TileUtils.numericSolve(A, b);
      H = [[h[0], h[1], 0, h[2]], [h[3], h[4], 0, h[5]], [0, 0, 1, 0], [h[6], h[7], 0, 1]];
  // Sanity check that H actually maps `from` to `to`
      for (i = m = 0; m < 4; i = ++m) {
        lhs = TileUtils.numericDotMV(H, [from[i].x, from[i].y, 0, 1]);
        k_i = lhs[3];
        rhs = TileUtils.numericDotSV(k_i, [to[i].x, to[i].y, 0, 1]);
      }
      return H;
    };
  
  
  public static buildMatrix3d(H:any) {
    
    let k,l, results;
    results = [];
    for (let i = k = 0; k < 4; i = ++k) {
      for (let j = l = 0; l < 4; j = ++l) {
        results.push(H[j][i].toFixed(20));
      }
    }
    
    return "matrix3d(" + results.join(',') + ")";
  }

  public static calcMatrix3d(from:IPoint[], to:IPoint[]) {
    return TileUtils.buildMatrix3d(TileUtils.calcTransform(from, to));
  }

}

class TileKey {
  readonly key:string;
  
  constructor(public readonly tileX:number, public readonly tileY:number, public readonly tileZoom:number) {
    this.key = this.tileZoom+"/"+this.tileX+"/"+this.tileY;
  }
}

abstract class MapTileBase {

  tileSize:number = 256;

  img:HTMLImageElement;

  tilePoints:IPoint[];
  tileMapPoints:IPoint[];
  tileDivPoints:IPoint[];


  constructor(public readonly tileKey:TileKey) {
  }

  public init(layer:MapLayerTilesBase) {
    let img = document.createElement('img');
    img.style.position = "absolute";
    img.style.userSelect = "none";
    img.src = this.getUrl();
    img.style.transformOrigin = "0px 0px";

    const lat1 = TileUtils.tile2lat(this.tileKey.tileY, this.tileKey.tileZoom);
    const long1 =TileUtils.tile2long(this.tileKey.tileX, this.tileKey.tileZoom);

    const lat2 = TileUtils.tile2lat(this.tileKey.tileY + 1, this.tileKey.tileZoom);
    const long2 = TileUtils.tile2long(this.tileKey.tileX + 1, this.tileKey.tileZoom);

    this.tilePoints = [
      {x:long1,y:lat1},
      {x:long1,y:lat2},
      {x:long2,y:lat1},
      {x:long2,y:lat2}
    ];
    this.tileMapPoints = this.tilePoints.map(p => ProjUtils.projForward(p));

    this.img = img;
    this.update(layer);
  }

  public update(layer:MapLayerTilesBase) {
    this.tileDivPoints = this.tileMapPoints.map(p => layer.map.fromMapPoint(p));
    let matrix3d = TileUtils.calcMatrix3d([{x:0, y:0},{x:0, y:this.tileSize},{x:this.tileSize, y:0},{x:this.tileSize, y:this.tileSize}], this.tileDivPoints);
    this.img.style.transform = matrix3d;
  }

  public abstract getUrl():string

}

export interface ITilesProvider {

  get caption():string;

  createTile(tileKey:TileKey):MapTileBase;

  calculateTileKeys(map:Map):TileKey[];

}


export abstract class TilesProvider implements ITilesProvider {

  abstract get caption():string;

  abstract createTile(tileKey:TileKey):MapTileBase;

  calculateTileKeys(map:Map):TileKey[] {
    let result:TileKey[] = [];

    let p1 = ProjUtils.projInverse({x:map.mapBounds.xMin,y:map.mapBounds.yMin});
    let p2 = ProjUtils.projInverse({x:map.mapBounds.xMax,y:map.mapBounds.yMax});

    let minLong = Math.min(p1.x, p2.x);
    let maxLong = Math.max(p1.x, p2.x);
    let minLat = Math.min(p1.y, p2.y);
    let maxLat = Math.max(p1.y, p2.y);

    let deltaLong = Math.abs(maxLong - minLong);

    let mapWidth = map.width;
    let zoom:number = 0;
    let tilesSize = 256;
    for (zoom = 0; zoom < 21; zoom++) {
      if ((tilesSize / 360 * deltaLong) > mapWidth) {
        break;
      }
      tilesSize *= 2;
    }

    console.log("zoom:" + zoom);

    let tileX1 = TileUtils.lon2tile(minLong, zoom);
    let tileX2 = TileUtils.lon2tile(maxLong, zoom);
    let tileY1 = TileUtils.lat2tile(minLat, zoom);
    let tileY2 = TileUtils.lat2tile(maxLat, zoom);

    let tileXMin = Math.min(tileX1, tileX2);
    let tileXMax = Math.max(tileX1, tileX2);
    let tileYMin = Math.min(tileY1, tileY2);
    let tileYMax = Math.max(tileY1, tileY2);

    console.log("tileX:[" + tileX1 +" - " + tileX2 +"]");
    console.log("tileY:[" + tileY1 +" - " + tileY2 +"]");



    let tilesNew:{[key:string]:MapTileBase} = {};

    for (let tileX = tileXMin; tileX <= tileXMax; tileX++) {
      for (let tileY = tileYMin; tileY <= tileYMax; tileY++) {
        result.push(new TileKey(tileX,tileY, zoom));
      }
    }

    return result;
  }
}



class MapTileOSM extends MapTileBase {

  public getUrl():string {
    return "https://c.tile.openstreetmap.org/"+this.tileKey.tileZoom+"/"+this.tileKey.tileX+"/"+this.tileKey.tileY+".png";
  }
}

export class TilesProviderOSM extends TilesProvider {

  get caption() {
    return "OpenStreetMap"
  }

  createTile(tileKey: TileKey): MapTileBase {
    return new MapTileOSM(tileKey);
  }

}


class MapTileBing extends MapTileBase {
  protected quadkey:string;

  protected tileXYToQuadKey():string {
    var quadKey = "";
    for (var i = this.tileKey.tileZoom; i > 0; i--) {
        let digit:number = 0;
        var mask = 1 << (i - 1);
        if ((this.tileKey.tileX & mask) !== 0) {
            digit++;
        }
        if ((this.tileKey.tileY & mask) !== 0) {
            digit++;
            digit++;
        }
        quadKey += String(digit);
    }
    return quadKey;
  }

  public getUrl():string {
    if (!this.quadkey) {
      this.quadkey = this.tileXYToQuadKey();
    }
    return "https://ecn.t3.tiles.virtualearth.net/tiles/a"+this.quadkey+".jpeg?g=13944";
  }


}

export class TilesProviderBing extends TilesProvider {
  get caption() {
    return "Bing"
  }

  createTile(tileKey: TileKey): MapTileBase {
    return new MapTileBing(tileKey);
  }

}


export abstract class MapLayerTilesBase extends MapLayer {

  public static TYPE = "MapLayerTilesBase";

  protected layerDiv:HTMLDivElement;

  protected attributionDiv:HTMLDivElement;

  protected tilesProvider:ITilesProvider;

  protected tiles:{[key:string]:MapTileBase} = {};
  protected showTileBorder:boolean = false;

  constructor(options:IMapLayerOptions) {
    super()
    this._id = options.id;
    this._caption = options.caption;
  }

  getLayerType() {
    return MapLayerTilesBase.TYPE;
  }


  _initCanvas(map:Map) {
    ProjUtils.init(map.crs);

    this.layerDiv = document.createElement('div');
    this.layerDiv.setAttribute('data-id',this._id);
    this.layerDiv.setAttribute('data-layer-type',this.getLayerType());
    this.layerDiv.classList.add('kelydra-map');
    this.layerDiv.style.width = map.width+"px";
    this.layerDiv.style.height = map.height+"px";
    this.layerDiv.style.position = 'absolute';
    this.layerDiv.style.overflow = 'hidden';
    this.layerDiv.style.transform = "scale(1, -1)";

    this.map._container.appendChild(this.layerDiv);

    this.attributionDiv = document.createElement('div');
    this.attributionDiv.style.position = "absolute";
    this.attributionDiv.style.bottom = "0px";
    this.attributionDiv.style.left = "0px";
    this.attributionDiv.style.border = "1px solid gray";
    this.attributionDiv.style.background = "white";
    this.attributionDiv.style.display = "none";

    super._initCanvas(map);
  };

  _resizeCanvas(size:{width:number, height:number}) {
    this.layerDiv.style.width = size.width+"px";
    this.layerDiv.style.height = size.height+"px";
    super._resizeCanvas(size);
  }

  protected showAttribution(html:string) {
    this.attributionDiv.innerHTML = html;
    this.attributionDiv.style.display = "";
  }


  protected drawTile(tileKey:TileKey, tilesOld:{[key:string]:MapTileBase}, tilesNew:{[key:string]:MapTileBase}):MapTileBase {
    let tile:MapTileBase;
    if (!tilesOld[tileKey.key]) {
      tile = this.tilesProvider.createTile(tileKey);
      tile.init(this);
      this.layerDiv.appendChild(tile.img);
      tilesNew[tileKey.key] = tile;
    } else {
      tile = tilesOld[tileKey.key];
      delete tilesOld[tileKey.key];
      tilesNew[tileKey.key] = tile;
      tile.update(this);
    }
    return tile;
  }

  draw() {
/*    

      let p1 = ProjUtils.projInverse({x:this.map.mapBounds.xMin,y:this.map.mapBounds.yMin});
      let p2 = ProjUtils.projInverse({x:this.map.mapBounds.xMax,y:this.map.mapBounds.yMax});

      let minLong = Math.min(p1.x, p2.x);
      let maxLong = Math.max(p1.x, p2.x);
      let minLat = Math.min(p1.y, p2.y);
      let maxLat = Math.max(p1.y, p2.y);

      let deltaLong = Math.abs(maxLong - minLong);

      let mapWidth = this.map.width;
      let zoom:number = 0;
      let tilesSize = 256;
      for (zoom = 0; zoom < 21; zoom++) {
        if ((tilesSize / 360 * deltaLong) > mapWidth) {
          break;
        }
        tilesSize *= 2;
      }

      console.log("zoom:" + zoom);

      let tileX1 = TileUtils.lon2tile(minLong, zoom);
      let tileX2 = TileUtils.lon2tile(maxLong, zoom);
      let tileY1 = TileUtils.lat2tile(minLat, zoom);
      let tileY2 = TileUtils.lat2tile(maxLat, zoom);

      let tileXMin = Math.min(tileX1, tileX2);
      let tileXMax = Math.max(tileX1, tileX2);
      let tileYMin = Math.min(tileY1, tileY2);
      let tileYMax = Math.max(tileY1, tileY2);

      console.log("tileX:[" + tileX1 +" - " + tileX2 +"]");
      console.log("tileY:[" + tileY1 +" - " + tileY2 +"]");



      let tilesNew:{[key:string]:MapTileBase} = {};

      for (let tileX = tileXMin; tileX <= tileXMax; tileX++) {
        for (let tileY = tileYMin; tileY <= tileYMax; tileY++) {
          this.drawTile(new TileKey(tileX,tileY, zoom), this.tiles, tilesNew);
        }
      }
*/      
/*
      this.drawTile(new TileKey(35226,23929, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35227, 23929, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35228, 23929, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35226,23928, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35227, 23928, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35228, 23928, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35226,23927, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35227, 23927, 16), this.tiles, tilesNew);
      this.drawTile(new TileKey(35228, 23927, 16), this.tiles, tilesNew);
*/  

      if (!this.tilesProvider) {
        return;
      }

      let tilesNew:{[key:string]:MapTileBase} = {};
      let keys = this.tilesProvider.calculateTileKeys(this.map);
      for (let tileKey of keys) {
        this.drawTile(tileKey, this.tiles, tilesNew);      
      }


      let toRemove = this.tiles;
      setTimeout(()=> {
        for (let tile of Object.values(toRemove)) {
          tile.img.remove();
        }
      },500);
      this.tiles = tilesNew;


      if (this.showTileBorder) {
        var context = this._canvas.getContext('2d');
        context.clearRect(0, 0, this._canvas.width, this._canvas.height);
        for (let tile of Object.values(this.tiles)) {
          context.beginPath();
          context.moveTo(tile.tileDivPoints[0].x, tile.tileDivPoints[0].y);
          context.lineTo(tile.tileDivPoints[1].x, tile.tileDivPoints[1].y);
          context.lineTo(tile.tileDivPoints[3].x, tile.tileDivPoints[3].y);
          context.lineTo(tile.tileDivPoints[2].x, tile.tileDivPoints[2].y);
          context.closePath();
          context.lineWidth = 1;
          context.strokeStyle = "red";
          context.stroke();
        }
      }





  };

  linkToMap(map:Map) {
      this.map = map;
      this._initCanvas(map);
  };

  setOpacity(value:number) {
    super.setOpacity(value);
    this.layerDiv.style.opacity = String(this._opacity); 
  }

  setVisibility(value:boolean) {
    super.setVisibility(value);
    if (value) {
        this.layerDiv.style.visibility = 'visible';
    } else {
     this.layerDiv.style.visibility = 'hidden';
    }
  }


}

export class MapLayerTilesOSM extends MapLayerTilesBase {
  public static TYPE = "MapLayerTilesOSM";


  constructor(options:IMapLayerOptions) {
    super(options);
    this.tilesProvider = new TilesProviderOSM();
  }

  getLayerType() {
    return MapLayerTilesBase.TYPE;
  }

}

export class MapLayerTilesBing extends MapLayerTilesBase {
  public static TYPE = "MapLayerTilesBing";

  constructor(options:IMapLayerOptions) {
    super(options);
    this.tilesProvider = new TilesProviderBing();
  }


  getLayerType() {
    return MapLayerTilesBase.TYPE;
  }

}

export class MapLayerTilesDynamic extends MapLayerTilesBase {
  public static TYPE = "MapLayerTilesDynamic";

  providers:ITilesProvider[] = [];

  constructor(options:IMapLayerOptions) {
    super(options);
  }

  getLayerType() {
    return MapLayerTilesBase.TYPE;
  }

  get providerIndex():number {
    return this.providers.indexOf(this.tilesProvider);
  }

  set providerIndex(value:number) {
    if (value >= 0 && value < this.providers.length) {
      this.tilesProvider = this.providers[value];
      let toRemove = this.tiles;
      this.tiles = {};
      for (let tile of Object.values(toRemove)) {
        tile.img.remove();
      }
      this.draw();
    } else {
      this.tilesProvider = null;
    }
  }


  addTilesProvider(tilesProvider:ITilesProvider):MapLayerTilesDynamic  {
    this.providers.push(tilesProvider);
    if (!this.tilesProvider) {
      this.tilesProvider = tilesProvider;
    }
    return this;
  }


}



